import axios from "axios";

/////// switch these when in dev for the backend
//  axios.defaults.baseURL = "https://mbt333.azurewebsites.net/";
 // axios.defaults.baseURL = "http://localhost:5001/";
 axios.defaults.baseURL = process.env.REACT_APP_APP_API_URL;
//  console.log(axios.defaults.baseURL, "ASE")
const instance = process.env.REACT_APP_APP_INSTANCE;

// Simple in-memory cache for API responses
const apiCache = new Map();
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const getCached = (key) => {
  const item = apiCache.get(key);
  if (!item) return null;
  if (Date.now() > item.expiry) {
    apiCache.delete(key);
    return null;
  }
  return item.value;
};

const setCache = (key, value, ttl = CACHE_TTL) => {
  apiCache.set(key, { value, expiry: Date.now() + ttl });
};

const clearCache = (pattern) => {
  for (const key of apiCache.keys()) {
    if (key.startsWith(pattern)) {
      apiCache.delete(key);
    }
  }
};

const Api = {

   //QUIZ & VIDEO TRACKING

  getVideoLog(user, video) {
    try {
      return axios(`api/${instance}/videos/log/${user}/${video}`, {
        method: "get"
      });
    } catch (err) {
      return err;
    }
  },

  logVideo(data) {
    // console.log(data, "LOG VIDEO")
    try {
      return axios(`api/${instance}/videos/log`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      });
    } catch (err) {
      return err;
    }
  },

  ///// QUIZZES

  // Get all quizzes (uses ?all=true for backwards compat, with caching)
  getAllQuizzes(options = {}) {
    const { useCache = true, noCache = false } = options;
    const cacheKey = `quizzes:all`;

    // Check cache first
    if (useCache && !noCache) {
      const cached = getCached(cacheKey);
      if (cached) {
        return Promise.resolve({ data: cached });
      }
    }

    try {
      const params = new URLSearchParams({ all: 'true' });
      if (noCache) params.append('noCache', 'true');

      return axios(`api/${instance}/quizzes/getall?${params}`, {
        method: "get",
      }).then(response => {
        // Cache the response
        if (useCache) {
          setCache(cacheKey, response.data);
        }
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  // Get quizzes with pagination (new)
  getQuizzesPaginated(page = 1, pageSize = 50, options = {}) {
    const { search = '', category = '' } = options;
    try {
      const params = new URLSearchParams({ page, pageSize });
      if (search) params.append('search', search);
      if (category) params.append('category', category);

      return axios(`api/${instance}/quizzes/getall?${params}`, {
        method: "get",
      });
    } catch (err) {
      return err;
    }
  },

  // Batch fetch multiple quizzes by IDs (new - prevents N+1)
  getQuizzesBatch(ids) {
    if (!ids || ids.length === 0) {
      return Promise.resolve({ data: {} });
    }
    try {
      return axios(`api/${instance}/quizzes/batch`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: { ids },
      });
    } catch (err) {
      return err;
    }
  },

  getOneQuiz(qid) {
    const cacheKey = `quiz:${qid}`;

    // Check cache first
    const cached = getCached(cacheKey);
    if (cached) {
      return Promise.resolve({ data: cached });
    }

    try {
      return axios(`api/${instance}/quizzes/getone/` + qid, {
        method: "get",
        id: qid,
      }).then(response => {
        setCache(cacheKey, response.data);
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  delOneQuiz(qid) {
    try {
      return axios(`api/${instance}/quizzes/delone/` + qid, {
        method: "delete",
        id: qid,
      }).then(response => {
        // Clear quiz cache on delete
        clearCache('quiz');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  newQuiz(data) {
    try {
      return axios(`api/${instance}/quizzes/newquiz`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      }).then(response => {
        // Clear quiz cache on create
        clearCache('quiz');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  updateQuiz(data) {
    try {
      return axios(`api/${instance}/quizzes/update`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      }).then(response => {
        // Clear quiz cache on update
        clearCache('quiz');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  ///// CATEGORIES

  // Get all categories (uses ?all=true for backwards compat, with caching)
  getAllCats(options = {}) {
    const { useCache = true, noCache = false } = options;
    const cacheKey = `categories:all`;

    // Check cache first
    if (useCache && !noCache) {
      const cached = getCached(cacheKey);
      if (cached) {
        return Promise.resolve({ data: cached });
      }
    }

    try {
      const params = new URLSearchParams({ all: 'true' });
      if (noCache) params.append('noCache', 'true');

      return axios(`api/${instance}/categories/getall?${params}`, {
        method: "get",
      }).then(response => {
        if (useCache) {
          setCache(cacheKey, response.data, 10 * 60 * 1000); // 10 min for categories
        }
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  // Get categories with pagination (new)
  getCatsPaginated(page = 1, pageSize = 50, options = {}) {
    const { search = '' } = options;
    try {
      const params = new URLSearchParams({ page, pageSize });
      if (search) params.append('search', search);

      return axios(`api/${instance}/categories/getall?${params}`, {
        method: "get",
      });
    } catch (err) {
      return err;
    }
  },

  getOneCat(cid) {
    try {
      return axios(`api/${instance}/categories/getone/` + cid, {
        method: "get",
        id: cid,
      });
    } catch (err) {
      return err;
    }
  },

  newCat(data) {
    try {
      return axios(`api/${instance}/categories/newcat`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      }).then(response => {
        clearCache('categories');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  updateCat(data) {
    try {
      return axios(`api/${instance}/categories/update`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      }).then(response => {
        clearCache('categories');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  ///// TRAINING COMPLETION REPORT

  getTrainingCompletionReport(search = '', page = 1, pageSize = 50, hoursFilter = 'all') {
    try {
      return axios(`api/${instance}/reports/training-completion`, {
        method: 'get',
        params: { search, page, pageSize, hoursFilter }
      });
    } catch (err) {
      return err;
    }
  },

  ///// EMAIL LISTS

  getAllELists() {
    try {
      return axios(`api/${instance}/emaillists/getall`, {
        method: "get",
      });
    } catch (err) {
      return err;
    }
  },

  newEList(data) {
    try {
      return axios(`api/${instance}/emaillists/newcat`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      });
    } catch (err) {
      return err;
    }
  },

  updateEList(data) {
    try {
      return axios(`api/${instance}/emaillists/update`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      });
    } catch (err) {
      return err;
    }
  },

  ///// VIDEOS

  // Get all videos (uses ?all=true for backwards compat, with caching)
  getAllVideos(options = {}) {
    const { useCache = true, noCache = false } = options;
    const cacheKey = `videos:all`;

    // Check cache first
    if (useCache && !noCache) {
      const cached = getCached(cacheKey);
      if (cached) {
        return Promise.resolve({ data: cached });
      }
    }

    try {
      const params = new URLSearchParams({ all: 'true' });
      if (noCache) params.append('noCache', 'true');

      return axios(`api/${instance}/videos/getall?${params}`, {
        method: "get",
      }).then(response => {
        if (useCache) {
          setCache(cacheKey, response.data);
        }
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  // Get videos with pagination (new)
  getVideosPaginated(page = 1, pageSize = 50, options = {}) {
    const { search = '', category = '' } = options;
    try {
      const params = new URLSearchParams({ page, pageSize });
      if (search) params.append('search', search);
      if (category) params.append('category', category);

      return axios(`api/${instance}/videos/getall?${params}`, {
        method: "get",
      });
    } catch (err) {
      return err;
    }
  },

  newVideo(data) {
    try {
      return axios(`api/${instance}/videos/newvideo`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data,
      }).then(response => {
        clearCache('videos');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  updateVideo(data) {
    try {
      return axios(`api/${instance}/videos/update`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      }).then(response => {
        clearCache('videos');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  createCert(data) {
    try {
      return axios(`api/${instance}/createCert/`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      });
    } catch (err) {
      return err;
    }
  },

  getQuizzes(id) {
    try {
      return axios(`api/${instance}/get-completed-quizzes/`+id, {
        method: "get",
        headers: {"Content-Type": "application/json"},
      });
    } catch (err) {
      return err;
    }
  },

  // Per-user completions from SQL QuizTracking (source of truth for the profile)
  getUserCompletions(userId) {
    try {
      return axios(`api/${instance}/user-completions/${userId}`, {
        method: "get",
        headers: {"Content-Type": "application/json"},
      });
    } catch (err) {
      return err;
    }
  },

  /////// EMAIL

  getGroupCode(gcid) {
    try {
      return axios(`api/${instance}/groupCode/get/` + gcid, {
        method: "get",
        id: gcid,
      });
    } catch (err) {
      return err;
    }
  },

  // Get all users (uses ?all=true for backwards compat, with caching)
  getAllUsers(query, options = {}) {
    const { useCache = true, noCache = false } = options;
    const cacheKey = `users:all:${query || 'default'}`;

    // Check cache first
    if (useCache && !noCache) {
      const cached = getCached(cacheKey);
      if (cached) {
        return Promise.resolve({ data: cached });
      }
    }

    try {
      let url = `/users/${instance}/getAllUsers`;
      // Add ?all=true for backwards compat
      const params = new URLSearchParams({ all: 'true' });
      if (query) {
        // Parse existing query string and merge
        const existingParams = new URLSearchParams(query.replace('?', ''));
        existingParams.forEach((value, key) => params.append(key, value));
      }
      url += '?' + params.toString();

      return axios(url, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {},
      }).then(response => {
        if (useCache) {
          setCache(cacheKey, response.data, 2 * 60 * 1000); // 2 min cache for users
        }
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  // Get users with pagination (new)
  getUsersPaginated(page = 1, pageSize = 50, options = {}) {
    const { search = '', terminated = false } = options;
    try {
      const params = new URLSearchParams({ page, pageSize });
      if (search) params.append('search', search);
      if (terminated) params.append('terminated', 'true');

      return axios(`/users/${instance}/getAllUsers?${params}`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {},
      });
    } catch (err) {
      return err;
    }
  },

  scanDuplicateEmployees(data) {
    try {
      return axios(`/users/${instance}/duplicates/scan`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data
      });
    } catch (err) {
      return err;
    }
  },

  previewDuplicateConsolidation(data) {
    try {
      return axios(`/users/${instance}/duplicates/preview-consolidation`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data
      });
    } catch (err) {
      return err;
    }
  },

  consolidateDuplicateEmployees(data) {
    try {
      return axios(`/users/${instance}/duplicates/consolidate`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data
      }).then(response => {
        clearCache('users');
        clearCache('certificates:status');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  updateGroupCode(data) {
    try {
      return axios(`api/${instance}/groupCode/update`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      });
    } catch (err) {
      return err;
    }
  },

  // MATRIX BUILDER

  bootstrapMatrix() {
    try {
      return axios(`api/${instance}/matrix/bootstrap`, {
        method: "get",
      });
    } catch (err) {
      return err;
    }
  },

  getTrainingMatrix() {
    try {
      return axios(`api/${instance}/matrix/training`, {
        method: "get",
      });
    } catch (err) {
      return err;
    }
  },

  saveTrainingMatrix(data) {
    try {
      return axios(`api/${instance}/matrix/training`, {
        method: "put",
        headers: {"Content-Type": "application/json"},
        data,
      });
    } catch (err) {
      return err;
    }
  },

  getJobCategoryMatrix() {
    try {
      return axios(`api/${instance}/matrix/job-categories`, {
        method: "get",
      });
    } catch (err) {
      return err;
    }
  },

  saveJobCategoryMatrix(data) {
    try {
      return axios(`api/${instance}/matrix/job-categories`, {
        method: "put",
        headers: {"Content-Type": "application/json"},
        data,
      });
    } catch (err) {
      return err;
    }
  },

  exportMatrix(type) {
    try {
      return axios(`api/${instance}/matrix/export?type=${encodeURIComponent(type)}`, {
        method: "get",
        responseType: "blob",
      });
    } catch (err) {
      return err;
    }
  },

  // AUTH

  login(data) {
    try {
      return axios(`auth/${instance}/login`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {...data, instance: process.env.REACT_APP_APP_INSTANCE},
      });
    } catch (err) {
      return err;
    }
  },

  reset_locked(data) {
    try {
      return axios(`auth/${instance}/reset-locked`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {email: data},
      });
    } catch (err) {
      return err;
    }
  },

  register(data) {
    try {
      return axios(`auth/${instance}/register`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      });
    } catch (err) {
      return err;
    }
  },

  makeAdmin(id) {
    try {
      return axios(`auth/${instance}/set-admin`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {UserID: id},
      }).then(response => {
        clearCache('users');
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  reset_password(data) {
    try {
      return axios(`auth/${instance}/reset-password`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data,
      });
    } catch (err) {
      return err;
    }
  },

  adminCreateTempPassword(data) {
    try {
      return axios(`auth/${instance}/admin-temp-password/create`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data
      });
    } catch (err) {
      return err;
    }
  },

  completeTempPasswordChange(data) {
    try {
      return axios(`auth/${instance}/admin-temp-password/complete-change`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data
      });
    } catch (err) {
      return err;
    }
  },

  get_profile(email) {
    try {
      return axios(`auth/${instance}/user/profile/` + email, {
        method: "get",
        headers: {"Content-Type": "application/json"},
      });
    } catch (err) {
      return err;
    }
  },
  save_profile(data) {
    try {
      return axios(`auth/${instance}/user/update-profile`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: data
      }).then(response => {
        clearCache('users');
        return response;
      });
    } catch (err) {
      return err;
    }
  },
  terminate(id) {
    try {
      return axios(`auth/${instance}/user/terminate`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {UserID: id}
      }).then(response => {
        clearCache('users');
        return response;
      });
    } catch (err) {
      return err;
    }
  },
  reinstate(id) {
    try {
      return axios(`auth/${instance}/user/terminate?reinstate=1`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {UserID: id}
      }).then(response => {
        clearCache('users');
        return response;
      });
    } catch (err) {
      return err;
    }
  },
  delete(id) {
    try {
      return axios(`auth/${instance}/user/delete`, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        data: {UserID: id}
      }).then(response => {
        clearCache('users');
        return response;
      });
    } catch (err) {
      return err;
    }
  },
  certificatesStatus(email, options = {}) {
    const { useCache = true, noCache = false, requestConfig = {} } = options;
    const cacheKey = `certificates:status:${email || 'all'}`;

    // Check cache first (shorter TTL for certificate status - 2 min)
    if (useCache && !noCache) {
      const cached = getCached(cacheKey);
      if (cached) {
        return Promise.resolve({ data: cached });
      }
    }

    try {
      let url = `notification/${instance}/expiration-alert`;
      if(email) url += "?user=" + email;
      const axiosConfig = {
        ...requestConfig,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          ...(requestConfig.headers || {})
        }
      };
      return axios(url, {
        ...axiosConfig
      }).then(response => {
        if (useCache) {
          setCache(cacheKey, response.data, 2 * 60 * 1000); // 2 min cache
        }
        return response;
      });
    } catch (err) {
      return err;
    }
  },

  // Utility to force refresh all caches
  refreshCache() {
    apiCache.clear();
  }
};

export default Api;
